import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const FilledTrendLineIcon = (props) => (
    <SvgIcon viewBox="0 0 19 14" sx={{ height: '14px', width: 'auto', ...props }}>
        <line
            x1="18.6992"
            y1="13.0073"
            x2="0.599903"
            y2="13.0073"
            stroke="currentColor"
            strokeWidth="1.17"
        />
        <line
            x1="1.18461"
            y1="0.57766"
            x2="1.18461"
            y2="13.4223"
            stroke="currentColor"
            strokeWidth="1.17"
        />
        <path
            d="M1.59961 12.9938L7.09961 6.7081L11.0996 8.27953L17.5996 1.99381"
            stroke="currentColor"
            strokeWidth="1.17"
            fill="none"
        />
        <path
            d="M6.98676 2.99772L1.14844 7.49772V13.2087L6.98676 6.41615L11.2454 8.1677L17.5986 1.99381L16.5989 1.07755L11.2454 4.49772L6.98676 2.99772Z"
            fill="currentColor"
            fillOpacity="0.3"
        />
        <path
            d="M5.92272 13.4223H1.66406L6.98739 6.41615L11.2461 8.1677L17.5994 2.07777L18.5994 3.07777L11.2461 11.4974L7.64911 10.5008L5.92272 13.4223Z"
            fill="currentColor"
            fillOpacity="0.3"
        />
    </SvgIcon>
);

export default FilledTrendLineIcon;
